import { IListaPeriodos } from './../../interfaces/ponderaciones';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IListaAnhos } from 'src/app/interfaces/ponderaciones';
import { environment } from 'src/environments/environment';
import { IBodyListado,IListaReportes } from 'src/app/interfaces/reporte-historico-calificaciones';

@Injectable({
  providedIn: 'root'
})
export class HistoricoCalificacionesService {

  constructor(
    private http:HttpClient
  ) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getFiltroAnhos(rut:string):Observable<IListaAnhos>{
    const url = `${environment.endpointAdministrativo}/v1/reporte-historico-calificacion/obtener-anyos?rut=${rut}`
    return this.http.get<IListaAnhos>(url, { headers: this.getHeaders() })
  }

  getFiltroPeriodo(rut:string, anyo: number):Observable<IListaPeriodos>{
    const url = `${environment.endpointAdministrativo}/v1/reporte-historico-calificacion/obtener-periodos?rut=${rut}&anyo=${anyo}`
    return this.http.get<IListaPeriodos>(url, { headers: this.getHeaders() })
  }

  getFiltroIdSeccion(rut:string, anyo: number, periodo:number){
    const url = `${environment.endpointAdministrativo}/v1/reporte-historico-calificacion/buscar-secciones?rut=${rut}&anyo=${anyo}&periodo-id=${periodo}`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  }

  obtenerListadoReportes(body: IBodyListado):Observable<IListaReportes> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-historico-calificacion/obtener-listado`
    return this.http.post<IListaReportes>(url, body, { headers: this.getHeaders() });
  }

  generarSolicitudReporte(body: IBodyListado):Observable<IListaReportes> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-historico-calificacion/genera-reporte`
    return this.http.post<IListaReportes>(url, body, { headers: this.getHeaders() });
  }

  obtenerReporteExcel(idSolicitud: number):Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-historico-calificacion/descargar-reporte-excel?proceso-id=${idSolicitud}`
    return this.http.get(url, {
      observe: 'response',
      headers: this.getHeaders(),
      responseType:'blob'
    })
  }

  obtenerReportePDF(idSolicitud: number):Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-historico-calificacion/descargar-reporte-pdf?proceso-id=${idSolicitud}`
    return this.http.get(url, {
      observe: 'response',
      headers: this.getHeaders(),
      responseType:'blob'
    })
  }
}
